import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import {
    pictureFormSchema,
    textFormSchema,
    slideFormSchema,
    masterFormSchema,
    connecterFormSchema,
    tableFormSchema,
    layoutFormSchema,
    effectLayoutFormSchema,
    noteFormSchema,
    chartFormSchema,
    barChartScheam,
    pieDoughnutChartScheam,
    bubbleChartScheam,
    smartArtFormSchema,
    textImageFormSchema,
    layoutImageFormSchema,
} from '@framework/workbench/schema/form';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { getMenuItems } from '@src/slide/application/service/menu-manager/menu-items';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { FormService } from '@tencent/wb-ext-form';
import { InjectorService } from '@tencent/workbench';
import { getChartElementFormKey } from '@framework/workbench/drawer/utils/chart';
import { FormPanelName } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { getPcInjectedService } from '@framework/workbench/util/injector-service';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { ChartService } from '@framework/workbench/common/service/chart-service';
import { isIframeShapeModel, isUiModelIsAttachment } from '@src/slide/domain/ui-model/elements/element-judge';
import { isImageConfigurableForShapeImageFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/image-fill/is-image-configurable';
import type { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import type { IMasterLayoutEditService } from '@src/slide/application/service/master-layout-edit-service/master-layout-edit-service.interface';
import type { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import type { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import type { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import type {  FormSchema } from '@tencent/wb-ext-form';
import type { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import type { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import type { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import {
    IRightSideBarManager,
} from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';
import { SelectedModelType } from '@src/slide/application/service/selection/selection-service.interface';
import { SubChartType } from '@tencent/slide-sdk-model';
import cloneDeep from 'lodash/cloneDeep';

export const OTHER_TYPE = 'other-type'; // 指第三方插件、本地上传的视频等，只展示layout。
export const OTHER_TYPE_EFFECT_LAYOUT = 'other-type-effect-layout'; // 指本地上传的文件如ppt等文本框形式，展示effect和layout。
export const SHAPE_IMAGE = 'shape-image';   // 图片填充的形状
export const LAYOUT_IMAGE = 'layout-image';
export const FormSchemaMap = {
    [UIModelType.SHAPE]: textFormSchema,
    [UIModelType.GROUP]: textFormSchema,
    [UIModelType.IMAGE]: pictureFormSchema,
    [UIModelType.EMPTY]: slideFormSchema,
    [UIModelType.CONNECTOR]: connecterFormSchema,
    [UIModelType.TABLE]: tableFormSchema,
    [UIModelType.NOTE]: noteFormSchema,
    [UIModelType.CHART]: chartFormSchema,
    [UIModelType.SMART_ART]: smartArtFormSchema,
    [OTHER_TYPE]: layoutFormSchema,
    [OTHER_TYPE_EFFECT_LAYOUT]: effectLayoutFormSchema,
    [SHAPE_IMAGE]: textImageFormSchema,
    [LAYOUT_IMAGE]: layoutImageFormSchema,
};
// 母版无动画schema
export const MasterFormSchemaMap = {
    [UIModelType.SHAPE]: textFormSchema,
    [UIModelType.GROUP]: textFormSchema,
    [UIModelType.IMAGE]: pictureFormSchema,
    [UIModelType.EMPTY]: masterFormSchema,
    [UIModelType.CONNECTOR]: connecterFormSchema,
    [UIModelType.TABLE]: tableFormSchema,
    [UIModelType.NOTE]: noteFormSchema,
    [UIModelType.CHART]: chartFormSchema,
    [UIModelType.SMART_ART]: smartArtFormSchema,
    [OTHER_TYPE]: layoutFormSchema,
    [OTHER_TYPE_EFFECT_LAYOUT]: effectLayoutFormSchema,
    [SHAPE_IMAGE]: textImageFormSchema,
    [LAYOUT_IMAGE]: layoutImageFormSchema,
};

// 图表侧边栏 数据系列操作 不同类型图表对应不同的scheam
export const ChartSeriesOptionsScheamMap = {
    [SubChartType.BarChart]: barChartScheam,
    [SubChartType.Bar3DChart]: barChartScheam,
    [SubChartType.PieChart]: pieDoughnutChartScheam,
    [SubChartType.Pie3DChart]: pieDoughnutChartScheam,
    [SubChartType.DoughnutChart]: pieDoughnutChartScheam,
    [SubChartType.BubbleChart]: bubbleChartScheam,
};
const MULTI_SAME_TYPE_LENGTH = 1;
const TWO_TYPE_LENGTH = 2;
const DEFAULT_VALUE = 0;
const ONLY_ONE_IMAGE_OR_SHAPE_IMAGE = 1;
const CHART_TAB_INDEX = 1;

interface IFormSchemaProps {
    menuManager: IMenuManager;
    userPriviledgeService: IUserPriviledgeService;
    masterLayoutEditService: IMasterLayoutEditService | undefined;
    rightSideBarManager: IRightSideBarManager | undefined;
}

export default class FormSchemaLogic {
    public static formService = InjectorService.get(FormService);
    private static chartService: ChartService;
    private static menuManager: IMenuManager;
    private static userPriviledgeService: IUserPriviledgeService;
    private static masterLayoutEditService: IMasterLayoutEditService | undefined;
    private static rightSideBarManager: IRightSideBarManager | undefined;


    public static init({
        menuManager,
        userPriviledgeService,
        masterLayoutEditService,
        rightSideBarManager,
    }: IFormSchemaProps) {
        this.menuManager = menuManager;
        this.userPriviledgeService = userPriviledgeService;
        this.masterLayoutEditService = masterLayoutEditService;
        this.rightSideBarManager = rightSideBarManager;
        this.chartService = getPcInjectedService(ChartService) as ChartService;
    }

    public static setFormSchema(model: SelectedModelType) {
        const FORM_SCHEMA = this.getSelectFormSchema(model);
        FormSchemaLogic.formService.setSchema(FORM_SCHEMA);
        if (model?.type === UIModelType.CHART) {
            this.switchToChartForm();
        }
    }

    public static getSelectFormSchema(model: SelectedModelType): FormSchema {
        let FORM_SCHEMA: FormSchema = textFormSchema;
        if (model?.type) {
            if ([UIModelType.MULTIPLY, UIModelType.GROUP].includes(model.type)) {
                const children = getAllChildModels(model as IMultiplyModel | IGroupModel);
                FORM_SCHEMA = FormSchemaLogic.getMultiModelFormSchema(children);
            } else if (model.type === UIModelType.CHART) {
                FORM_SCHEMA = this.getChartFormSchema(model as IChartModel);
            } else {
                const newType = FormSchemaLogic.getNewType(model?.type, model as IElementBaseModel);
                FORM_SCHEMA = FormSchemaLogic.getFormSchema()[newType];
            }
        }
        return FORM_SCHEMA;
    }

    /**
     * 获取图表侧边栏schema
     * @param mode
     * @param showMarker? 是否展示marker面板（仅在线条图形下生效）
     * @returns
     */
    public static getChartFormSchema(model: IChartModel) {
        if (!model.isActualRenderChart) {
            this.reportChartForm(model.isActualRenderChart);
            return FormSchemaLogic.getFormSchema()[OTHER_TYPE];
        }
        let CHART_SCHEMA = FormSchemaLogic.getFormSchema()[UIModelType.CHART];
        const showMarker = this.chartService.showMarkerPanel();
        const formatKey = getChartElementFormKey(model, showMarker);
        CHART_SCHEMA = this.loadScheamBySubChartType(model, cloneDeep(CHART_SCHEMA), formatKey);
        const FORM_SCHEMA = {
            [FormPanelName.SHAPE]: {
                ...CHART_SCHEMA[formatKey],
                label: i18n.t('形状'),
            },
        };
        this.reportChartForm(model.isActualRenderChart, formatKey);
        return FORM_SCHEMA;
    }

    /**
     * 根据选中的图表类型动态加载不同图表数据系列选项scheam
     * @param mode ChartModel
     * @param CHART_SCHEMA 图表的全部侧边栏的scheam
     * @param formatKey 将要展示的侧边栏的key
     * @returns CHART_SCHEMA
     */
    private static loadScheamBySubChartType(model: IChartModel, CHART_SCHEMA, formatKey) {
        const originType = model.getSelectedSubChartProperty()?.getChartOriginType();
        if (!originType) return CHART_SCHEMA;
        if (!ChartSeriesOptionsScheamMap[originType]) return CHART_SCHEMA;
        CHART_SCHEMA[formatKey]?.tabs.forEach((item) => {
            if (item?.label === i18n.t('数据系列')) {
                item?.sections.push(ChartSeriesOptionsScheamMap[originType]);
            }
        });
        return CHART_SCHEMA;
    }

    /**
     * 切换至图表设置侧边栏
     */
    private static switchToChartForm() {
        FormSchemaLogic.formService.changeForm(FormPanelName.SHAPE, CHART_TAB_INDEX);
        if (this.rightSideBarManager?.isAnimationEditorShown) {
            this.rightSideBarManager.setIsAnimationEditorShown(false);
            this.rightSideBarManager.setIsPropertyEditorShown(true);
        }
    }

    private static getNewType = (type: string, model: IElementBaseModel) => {
        if (type === UIModelType.NOTE || type === UIModelType.CHART) {
            return type;
        }
        const AddonOrAttachmentType = FormSchemaLogic.getTextAddonOrAttachmentType(model);
        if (AddonOrAttachmentType) return AddonOrAttachmentType;

        if (FormSchemaLogic.menuManager.propertyMenu()?.items?.length === 0
        || getMenuItems(MenuType.PROPERTY_BAR, model).length === 0) {
            return OTHER_TYPE;
        }

        if (isImageConfigurableForShapeImageFill(model)) {
            return SHAPE_IMAGE;
        }

        if (model.type === UIModelType.SHAPE && (model as IShapeModel).isTextMath) {
            return OTHER_TYPE_EFFECT_LAYOUT;
        }

        return type;
    };

    private static getMultiModelFormSchema(selectedModels: IElementBaseModel[]) {
        // 如果有任意一个是附件，格式只显示布局
        if (selectedModels.some(model => isUiModelIsAttachment(model) || isIframeShapeModel(model))) {
            return layoutFormSchema;
        }
        // 相同类型，展示其类型对应数据
        // 不同类型，只有是文本和纯图片时展示样式和布局，其余全部展示布局
        const typeArray: string[] = [];
        let imageOrImageFillNum = DEFAULT_VALUE;
        selectedModels.forEach((model) => {
            let newType = this.getNewType(model?.type, model);
            if (newType === SHAPE_IMAGE) {
                imageOrImageFillNum += 1;
                newType = UIModelType.SHAPE;
            }
            if (newType === UIModelType.IMAGE) {
                imageOrImageFillNum += 1;
            }
            if (typeArray.indexOf(newType) === -1) {
                typeArray.push(newType);
            }
        });
        const { length } = typeArray;
        if (length === MULTI_SAME_TYPE_LENGTH) {
            return this.getMultiSameTypeSchema(selectedModels[0].type, typeArray, imageOrImageFillNum);
        }
        return this.getMultiDifferentTypeSchema(typeArray, imageOrImageFillNum);
    }

    private static getMultiDifferentTypeSchema(typeArray: string[], imageOrImageFillNum: number) {
        // 多选元素中包含形状时，返回形状 schema
        const hasShape = typeArray.filter(item => item === UIModelType.SHAPE).length >= 1;
        const hasChart = typeArray.filter(item => item === UIModelType.CHART).length >= 1;
        const hasOtherType = typeArray.filter(item => item === OTHER_TYPE_EFFECT_LAYOUT).length >= 1;
        if (imageOrImageFillNum === ONLY_ONE_IMAGE_OR_SHAPE_IMAGE) {
            return (hasShape && !(hasOtherType || hasChart)) ? this.getFormSchema()[SHAPE_IMAGE]
                : this.getFormSchema()[UIModelType.IMAGE];
        }
        if (hasShape) {
            return (hasOtherType || hasChart) ? this.getFormSchema()[OTHER_TYPE_EFFECT_LAYOUT]
                : this.getFormSchema()[UIModelType.SHAPE];
        }
        if (hasOtherType) {
            return this.getFormSchema()[OTHER_TYPE_EFFECT_LAYOUT];
        }
        return this.getFormSchema()[OTHER_TYPE];
    }

    private static getMultiSameTypeSchema(type: string, typeArray: string[], imageOrImageFillNum: number) {
        switch (type) {
            case UIModelType.IMAGE:
                // 多选图片/图标仅显示样式和布局
                return effectLayoutFormSchema;
            case UIModelType.CHART:
                return this.getFormSchema()[OTHER_TYPE];
            case UIModelType.SHAPE:
                return imageOrImageFillNum === ONLY_ONE_IMAGE_OR_SHAPE_IMAGE
                    ? this.getFormSchema()[SHAPE_IMAGE]
                    : this.getFormSchema()[UIModelType.SHAPE];
            default:
                return this.getFormSchema()[typeArray[0]];
        }
    }

    /**
     * 获取特殊类型，如附件，本地文件等
     */
    private static getTextAddonOrAttachmentType = (model: IElementBaseModel) => {
        // 附件都侧边栏都只显示布局
        if (isUiModelIsAttachment(model)) {
            return OTHER_TYPE;
        }
        if (model?.type !== UIModelType.SHAPE) return;
        const selectedModel = model as IShapeModel;
        // 无预览图，附件只展示布局
        if (selectedModel.props.addon && selectedModel.props.addon.displayMode !== 'normal') {
            return OTHER_TYPE;
        }
    };

    private static getFormSchema = () => {
        const isMasterEditType = FormSchemaLogic.getMasterLayoutEditService()?.isMasterEditType;
        if (isMasterEditType) {
            return MasterFormSchemaMap;
        }
        return FormSchemaMap;
    };

    private static getMasterLayoutEditService = () => {
        if (!FormSchemaLogic.userPriviledgeService.isEditable()) {
            return undefined;
        }
        return FormSchemaLogic.masterLayoutEditService;
    };

    /**
     *
     * @param isChart 是否是图表，否则是图表图片
     * @param formKey 图表组件表单标识
     */
    private static reportChartForm(isChart, formKey?) {
        const ver6Param = JSON.stringify({
            isChart,
            formKey,
        });

        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.CHART,
            action: TDWActionType.CHART_RIGHT_BAR_DISPALY,
            ver6: ver6Param,
        });
    }
}
